import { combineLoaders } from '@/lib/loader/combine-loader';
import { permissionsLoader } from '@/lib/loader/permission-loader';
import { lazy } from 'react';
import { redirect } from 'react-router';
import { FeatureFlagKey } from '@/features/feature-flag/feature-flag.constants';
import { withFeature } from '@/features/feature-flag/components/with-feature';

const BookingPage = lazy(() => import('./page'));
const EditBookingFormPage = lazy(() => import('./page/edit-form'));
// The day builder is the one create flow.
const CreateBookingFormPage = lazy(() => import('./page/parallel-form'));
const PaymentOverviewPreviewPage = lazy(
  () => import('./payment-overview/payment-overview-preview-page')
);

export const BookingRoute = [
  {
    path: '/bookings',
    Component: BookingPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/bookings/form',
    Component: CreateBookingFormPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    // Old address of the same screen, kept for bookmarks and open tabs.
    path: '/bookings/parallel-form',
    loader: ({ request }: { request: Request }) =>
      redirect(`/bookings/form${new URL(request.url).search}`),
  },
  {
    path: '/bookings/form/:id',
    Component: EditBookingFormPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/bookings/form/:id/betaaloverzicht',
    Component: withFeature(
      FeatureFlagKey.MODULE_PAYMENT_OVERVIEW,
      PaymentOverviewPreviewPage,
      '/bookings'
    ),
    loader: combineLoaders(permissionsLoader),
  },
];
